<template>
  <div>
    <Row :gutter="8">
      <Col span="4">
        <Select v-model="year" placeholder="选择年份" clearable @on-change="search">
          <Option v-for="y in yearList" :key="y" :value="y">{{ y }}</Option>
        </Select>
      </Col>
      <Col span="6">
        <Button type="primary" icon="ios-search" @click="search" style="margin-right:5px">查询</Button>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Table border ref="table" size="small" :columns="columns" :data="tableData" :height="tableHeight"></Table>
      </Col>
    </Row>

    <Modal v-model="detailModal" :title="'积分明细 - ' + detailName" width="960">
      <Tabs :value="detailTab" @on-click="t => detailTab = t">
        <TabPane label="获取记录" name="earn">
          <Table border size="small" :columns="detailColumns" :data="detailEarnData" :height="400"></Table>
        </TabPane>
        <TabPane label="兑换记录" name="exchange">
          <Table border size="small" :columns="exchangeColumns" :data="detailExchangeData" :height="400"></Table>
        </TabPane>
      </Tabs>
      <div slot="footer">
        <Button type="default" @click="detailModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "integralPeopleItemStatistics",
  data() {
    return {
      year: new Date().getFullYear() + "",
      yearList: [],
      detailModal: false,
      detailName: "",
      detailIdCard: "",
      detailTab: "earn",
      detailEarnData: [],
      detailExchangeData: [],
      columns: [
        { title: "序号", width: 80, align: "center", render: (h, p) => h("span", p.index + 1) },
        { title: "姓名", key: "name", minWidth: 120, align: "center", tooltip: true },
        { title: "身份证号码", key: "idCard", minWidth: 200, align: "center", tooltip: true },
        { title: "获取总积分", key: "totalBranch", minWidth: 100, align: "center", tooltip: true },
        { title: "剩余积分", key: "remainBranch", minWidth: 100, align: "center", tooltip: true,
          render: (h, p) => {
            let val = p.row.remainBranch != null ? p.row.remainBranch : p.row.totalBranch;
            return h("span", { style: { color: "#2d8cf0", cursor: "pointer" }, on: { click: () => this.viewDetail(p.row) } }, val);
          }
        },
      ],
      detailColumns: [
        { title: "日期", key: "recordDate", minWidth: 120, align: "center" },
        { title: "姓名", key: "name", minWidth: 100, align: "center" },
        { title: "身份证号码", key: "idCard", minWidth: 180, align: "center", tooltip: true },
        { title: "参与大类", key: "category", minWidth: 180, align: "center" },
        { title: "具体事项", key: "detail", minWidth: 200, align: "center" },
        { title: "积分", key: "branch", minWidth: 80, align: "center" },
      ],
      exchangeColumns: [
        { title: "礼品名称", key: "giftName", minWidth: 130, align: "center" },
        { title: "积分单价", key: "integralBranch", minWidth: 80, align: "center" },
        { title: "兑换数量", key: "exchangeCount", minWidth: 80, align: "center" },
        { title: "消耗积分", key: "totalBranch", minWidth: 80, align: "center" },
        { title: "兑换时间", key: "exchangeTime", minWidth: 160, align: "center" },
        { title: "状态", key: "status", minWidth: 80, align: "center",
          render: (h, p) => h("span", p.row.status == 10 ? "已审核" : p.row.status == 15 ? "已拒绝" : "待审核") },
      ],
      tableData: [], tableHeight: 500,
    };
  },
  created() { this.initYearList(); this.getData(); },
  mounted() { this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220; },
  methods: {
    initYearList() { var y = new Date().getFullYear(); for (var i = y - 4; i <= y; i++) this.yearList.push(i + ""); },
    getData() {
      let msg = this.$Message.loading({ content: "正在获取数据", duration: 0 });
      let params = {};
      if (this.year) params.year = this.year;
      this.$http.get("/api/tIntegralPeopleItem/statistics", { params }).then(r => { msg(); if (r.data.code == 200) this.tableData = r.data.data; }).catch(() => msg());
    },
    search() { this.getData(); },
    viewDetail(row) {
      this.detailName = row.name;
      this.detailIdCard = row.idCard;
      this.detailModal = true;
      this.detailTab = "earn";
      let year = this.year;
      // 获取积分记录
      let params1 = { idCard: row.idCard, status: 10, pageSize: 999 };
      if (year) params1.year = year;
      this.$http.get("/api/tIntegralPeopleItem/page", { params: params1 }).then(r => { if (r.data.code == 200) this.detailEarnData = r.data.data.list || []; });
      // 获取兑换记录
      let params2 = { name: row.name, status: 10, pageSize: 999 };
      if (year) params2.year = year;
      this.$http.get("/api/tGiftExchange/page", { params: params2 }).then(r => { if (r.data.code == 200) this.detailExchangeData = r.data.data.list || []; });
    },
  },
};
</script>
<style scoped>.ivu-row { margin-bottom: 10px; }</style>
